
const $fd1b2488e7aa05b6$var$form = document.querySelector(".form");
const $fd1b2488e7aa05b6$var$ratingComponent = document.querySelectorAll(".rating-component");
const $fd1b2488e7aa05b6$var$ratingText = document.querySelectorAll(".rating-text");
const $fd1b2488e7aa05b6$var$selectionTxt = document.querySelector(".selection-text");
const $fd1b2488e7aa05b6$var$ratingSection = document.querySelector(".rating-section");
const $fd1b2488e7aa05b6$var$backSection = document.querySelector(".back-section");
$fd1b2488e7aa05b6$var$form.addEventListener("submit", $fd1b2488e7aa05b6$var$handleSubmit);
$fd1b2488e7aa05b6$var$form.addEventListener("submit", $fd1b2488e7aa05b6$var$showBack);
function $fd1b2488e7aa05b6$var$handleSubmit(e) {
    e.preventDefault();
    let ratingValue;
    $fd1b2488e7aa05b6$var$ratingComponent.forEach((component)=>{
        if (component.checked) ratingValue = component.value;
    });
    $fd1b2488e7aa05b6$var$selectionTxt.textContent = `You selected ${ratingValue} out of 5`;
}
function $fd1b2488e7aa05b6$var$showBack(e) {
    e.preventDefault();
    $fd1b2488e7aa05b6$var$ratingSection.classList.remove("shown-card");
    $fd1b2488e7aa05b6$var$ratingSection.classList.add("hidden-card");
    $fd1b2488e7aa05b6$var$backSection.classList.add("shown-card");
    $fd1b2488e7aa05b6$var$backSection.classList.remove("hidden-card");
}
$fd1b2488e7aa05b6$var$ratingText.forEach((item)=>{
    item.addEventListener("click", ()=>{
        $fd1b2488e7aa05b6$var$ratingText.forEach((ifChecked)=>{
            ifChecked.classList.remove("checked");
        });
        item.classList.add("checked");
    });
});


console.log("Parcel is working. Hurray!");


//# sourceMappingURL=index.e3a35a2f.js.map
